import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-images.css';
import { v as validatePropType } from '../validate-prop-types/index-chunk.esm.js';

// Image Fit Types
const EGDSImageFitMap = [
    ['cover', 'fit-cover'],
    ['contain', 'fit-contain'],
];
const EGDSImageFits = new Map(EGDSImageFitMap);
// Roundcorner Types
const EGDSRoundcornerPropMap = [
    ['all', 'all'],
    ['max', 'max'],
    ['startstart', 'startstart'],
    ['startend', 'startend'],
    ['endstart', 'endstart'],
    ['endend', 'endend'],
];
const EGDSRoundcorners = new Map(EGDSRoundcornerPropMap);

const getClassNameList$2 = classNames.bind(styles);
var EGDSFigureAspectRatioType;
(function (EGDSFigureAspectRatioType) {
    EGDSFigureAspectRatioType["R1_1"] = "ratio-1-1";
    EGDSFigureAspectRatioType["R4_3"] = "ratio-4-3";
    EGDSFigureAspectRatioType["R3_2"] = "ratio-3-2";
    EGDSFigureAspectRatioType["R16_9"] = "ratio-16-9";
    EGDSFigureAspectRatioType["R21_9"] = "ratio-21-9";
    EGDSFigureAspectRatioType["R3_4"] = "ratio-3-4";
    EGDSFigureAspectRatioType["R4_1"] = "ratio-4-1";
})(EGDSFigureAspectRatioType || (EGDSFigureAspectRatioType = {}));
class EGDSFigure extends React.Component {
    static displayName = 'EGDSFigure';
    static AspectRatio = EGDSFigureAspectRatioType;
    render() {
        const { className, children, ratio, src, roundcorner, imageFit, additionalProps, style } = this.props;
        const Tag = src ? 'div' : 'figure';
        const handleRoundcornerClassArray = (classArr, propArr, baseClass) => {
            propArr.forEach((arrayValue) => classArr.push(`${baseClass}-${EGDSRoundcorners.get(arrayValue)}`));
        };
        const roundcornerClass = (prop) => {
            const roundcornerBaseClass = 'uitk-image-roundcorner';
            const propType = typeof prop;
            const classArr = [];
            const propIsArray = Array.isArray(prop);
            if (propType === 'boolean') {
                // Prop type is boolean
                classArr.push(`${roundcornerBaseClass}-all`);
            }
            else if (propIsArray) {
                // Prop type is array
                handleRoundcornerClassArray(classArr, prop, roundcornerBaseClass);
            }
            else {
                // Prop type is object
                const object = prop;
                Object.getOwnPropertyNames(object).forEach((breakpointKey) => {
                    const breakRoundcornerBaseClass = `${roundcornerBaseClass}-${breakpointKey}`;
                    if (Array.isArray(object[breakpointKey])) {
                        handleRoundcornerClassArray(classArr, object[breakpointKey], breakRoundcornerBaseClass);
                    }
                    else {
                        // UitkRoundcornerBreakSetting type
                        const cornerObject = object[breakpointKey];
                        Object.getOwnPropertyNames(cornerObject).forEach((cornerKey) => {
                            if (cornerObject[cornerKey] === 'set') {
                                classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}`);
                            }
                            else if (cornerObject[cornerKey] === 'unset')
                                classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}-unset`);
                        });
                    }
                });
            }
            return classArr;
        };
        const classList = getClassNameList$2('uitk-image', className, roundcorner && roundcornerClass(roundcorner), imageFit && `uitk-image-${EGDSImageFits.get(imageFit)}`, {
            [`uitk-image-${ratio}`]: validatePropType(ratio, EGDSFigureAspectRatioType),
            'uitk-image-ratio': validatePropType(ratio, EGDSFigureAspectRatioType),
        }, { [`uitk-image-ratio-2-1`]: !ratio, 'uitk-image-ratio': !ratio, 'uitk-image-background': src });
        let cssStyle = {};
        if (style) {
            cssStyle = style;
        }
        else if (src) {
            cssStyle = { backgroundImage: `url("${src}")` };
        }
        const newProps = {
            className: classList,
            style: cssStyle,
            ...additionalProps,
        };
        return jsx(Tag, { ...newProps, children: children });
    }
}

const getClassNameList$1 = classNames.bind(styles);
class EGDSImage extends React.Component {
    static displayName = 'EGDSImage';
    static defaultProps = {
        blankDefault: false,
        src: '',
    };
    constructor(props) {
        super(props);
        this.state = {
            hideImage: false,
            hidePlaceholderImage: false,
        };
        this.handleError = this.handleError.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        const { hideImage } = this.state;
        if (nextProps.src && hideImage === true) {
            // This manually triggers an update and then forces a false to prevent a loop
            this.setState({
                hideImage: false,
            });
            return false;
        }
        return true;
    }
    handleError(event) {
        const { blankDefault, placeholderImage, additionalProps } = this.props;
        this.setState({
            hideImage: !!placeholderImage || !!blankDefault,
        });
        if (additionalProps) {
            // To get around TypeScript error "Property does not exist on type object"
            const castedProps = additionalProps;
            if (castedProps.onError && typeof castedProps.onError === 'function') {
                castedProps.onError(event);
            }
        }
    }
    handleSuccess(event) {
        const { additionalProps } = this.props;
        if (!additionalProps?.['data-lazy']) {
            this.setState({
                hidePlaceholderImage: true,
            });
        }
        if (additionalProps) {
            // To get around TypeScript error "Property does not exist on type object"
            const castedProps = additionalProps;
            if (castedProps.onLoad && typeof castedProps.onLoad === 'function') {
                castedProps.onLoad(event);
            }
        }
    }
    render() {
        const { blankDefault, className, placeholderImage, alt, src, imgRef, lazyLoading, additionalProps } = this.props;
        const { hideImage, hidePlaceholderImage } = this.state;
        const imageClasses = getClassNameList$1('uitk-image-media', className);
        const placeholderClass = getClassNameList$1('uitk-image-placeholder', {
            [`uitk-image-placeholder-image`]: placeholderImage && !blankDefault && !hidePlaceholderImage,
        });
        const lowerCaseAttributes = Object.fromEntries(Object.entries(additionalProps || {}).map(([key, value]) => [key.toLowerCase(), value]));
        const imageProps = {
            className: imageClasses,
            ref: imgRef,
            src,
            ...lowerCaseAttributes,
        };
        return (jsx("div", { className: placeholderClass, children: !hideImage && (jsx("img", { alt: alt, ...imageProps, onError: this.handleError, onLoad: this.handleSuccess, loading: lazyLoading === 'off' ? undefined : lazyLoading })) }));
    }
}

class LimitedStringSet {
    _size;
    data;
    maxSize;
    constructor(maxSize = 100) {
        this._size = 0;
        this.data = {};
        this.maxSize = maxSize;
    }
    add(value) {
        if (this.has(value)) {
            return;
        }
        if (this.length >= this.maxSize) {
            this.removeFirst();
        }
        this.data[value] = true;
        this._size += 1;
    }
    remove(value) {
        if (this.data[value]) {
            delete this.data[value];
            this._size -= 1;
        }
    }
    removeFirst() {
        for (const value in this.data) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.data.hasOwnProperty(value)) {
                delete this.data[value];
                this._size -= 1;
                break;
            }
        }
    }
    has(value) {
        return Boolean(this.data[value]);
    }
    get length() {
        return this._size;
    }
}

const MAX_SET_SIZE = 100;
/**
 * ImageQueue Notes:
 * - Does not handle duplicate entries any differently. (LOC to ROI is very poor)
 */
class ImageQueue {
    maxConnections;
    queue;
    runners;
    completedUrls;
    constructor({ maxConnections } = { maxConnections: 3 }) {
        this.reset();
        this.maxConnections = maxConnections;
    }
    reset() {
        this.queue = [];
        this.runners = [];
        this.completedUrls = new LimitedStringSet(MAX_SET_SIZE);
    }
    /*
      Source = string identifier, eg: 'hsr'
      imageUrl (required) = image to download
      imgRef = ref to an existing Image to load image to
      callback = (error) => {}
     */
    enqueue({ source, imageUrl, imgRef, callback }) {
        this.queue.push({ source, imageUrl, imgRef, callback });
        if (this.runners.length < this.maxConnections) {
            this._loadImages();
        }
    }
    dequeue(imageUrl, source) {
        this.queue = this.queue.filter((item) => !(item.imageUrl === imageUrl && (!source || item.source === source)) // Easier to reason about !(dequeueMatch) for filtering
        );
    }
    dequeueAll(source) {
        this.queue = this.queue.filter((item) => item.source !== source);
    }
    _loadImages() {
        this.queue.splice(0, this.maxConnections - this.runners.length).forEach((task) => {
            this._downloadImage(task);
        });
    }
    _downloadImage(task) {
        const image = task.imgRef || new Image();
        const handler = (error) => () => {
            const index = this.runners.findIndex((item) => item.imageUrl === task.imageUrl && (!task.source || item.source === task.source));
            if (index >= 0) {
                this.runners.splice(index, 1);
            }
            Promise.resolve().then(() => this._loadImages());
            this.completedUrls.add(task.imageUrl);
            if (task.callback) {
                // Call the callback immediately to prevent image-change jitter.
                task.callback(error);
            }
        };
        if (this.completedUrls.has(task.imageUrl)) {
            handler()();
            return;
        }
        image.onerror = handler(new Error(`Error loading image URL: ${task.imageUrl}`));
        image.onload = handler();
        image.src = task.imageUrl;
        // eslint-disable-next-line no-param-reassign
        task.imgRef = image;
        this.runners.push(task);
    }
}
const queue = new ImageQueue({ maxConnections: 4 });

const getClassNameList = classNames.bind(styles);
const EGDSImageLink = ({ children }) => {
    const childrenArray = React.Children.toArray(children).filter((child) => React.isValidElement(child));
    if (childrenArray.length === 0) {
        return null;
    }
    const firstChild = childrenArray[0];
    const { className } = firstChild.props;
    const classList = getClassNameList('uitk-image-link', className);
    const clonedElement = React.cloneElement(firstChild, {
        className: classList,
    }, jsx("span", { className: "is-visually-hidden", children: firstChild.props.children }));
    return clonedElement;
};
EGDSImageLink.displayName = 'EGDSImageLink';

export { EGDSFigureAspectRatioType as E, EGDSFigure as a, EGDSImage as b, EGDSImageLink as c, EGDSImageFits as d, EGDSRoundcorners as e, queue as q };
//# sourceMappingURL=index-chunk.esm.js.map
